export const ab = {
  status: 200,
  message: 'success',
  lastFetchedTimestamp: 1593068163954,
  data: {
    PCRDF: 0,
    PFA: 1,
    OTP: 0,
    mnthn: false,
    PFP: 1,
    DDDF: 0,
    MFEP: 0,
    DGF: 0,
    CABS: 1,
    FCN: false,
    DGT: 3,
    SED: 0,
    ZCA: 0,
    ZCE: 1,
    CABF: 0,
    travellerScan: 0,
    NTD: 1,
    NLA: 0,
    dgi: 1,
    IRR: 0,
    ZCS: 1,
    SNH: 0,
    FLS: 1,
    LPS: 0,
    SFN: 0,
    ZC_Client_Side_exp: false,
    FUS: 1,
    USF: 0,
    MCC: 1,
    MCD: 0,
    BAGR: 1,
    SOR: 0,
    msa: 1,
    PRB: 0,
    msf: 0,
    PRE: 2,
    pwa_login_type: 0,
    NDAST: 0,
    cnpn: 1,
    ITT: 1,
    CLS: 1,
    PFI: 1,
    ZC_Server_Side_experiment1: 1,
    CHMRK: 1,
    BSG: 1,
    PBC: 0,
    AMD: 0,
    AME: 0,
    SHR: 0,
    IMB: 0,
    CID: 1,
    bottomsheet_onetap_pwa: '1',
    BNTD: 0,
    mbrt: 0,
    TSC: 0,
    trvlr: true,
    CAD: 1,
    IMS: 0,
    UMF: 0,
    mbit: 0,
    mdl: 0,
    DTD: 1,
    ANC: 1,
    SIM: 1,
    PTA: 0,
    HLD: 0,
    ANP: 1,
    PTF: 0,
    cheaperFlightsDesktopDom: 1,
    ANU: 1,
    MFA: 0,
    MFD: 0,
    MFC: 1,
    MFEA: 0,
    MFI: 0,
    LLS: 1,
    AOA: 0,
    SRT: 0,
    MFMD: 1,
    BIRT: 0,
    PLS: 1,
    AOD: 0,
    MFP: 1,
    flightPageLoadTracking: 0,
    NHP: 0,
    MFEI: 0,
    GSF: 0,
    AOI: 0,
    MFED: 1,
    QFT: 1,
    AOP: 0,
    BAA: 0,
    AGGRNEW: 1,
    BII: 1,
    ADDONM: 0,
    FAA: 0,
    MFTD: 0,
    BAN: 0,
    GYOLO: 0,
    APD: 0,
    FAO: 0,
    FAT: 0,
    PET: 1,
    EMI: 0,
    BRB: 1,
    PWA: 1,
    NUG: 0,
    WCM: 2,
    LISTN: 1,
    LFT: 2,
    RTM: 1,
    INT: 1,
    RNP: 0,
    ALF: 1,
    COU: 2,
    SEM: 1,
    SPA: 1,
    STA: 1,
    BFFL: 1,
    GRPC: 1,
    FLK: 1,
    IFFLK: 1,
  },
  allocationInfo: {
    nonTracking: '3ue|5t7|5th|5yh',
    tracking: {
      FLIGHTSV2: '3vr|3w2|4tx|5s5',
    },
  },
};
